import ReactDOM from 'react-dom';
import React from 'react';
import { getJSONFromHtml } from '../../../domain/common';
import TopMenuDesktop from './ui/drop-down-menu/main';
import { ITopMenuDesktop } from './interfaces';

export const initTopMenuDesktop = () => {
    const $root = document.getElementById('top-menu-d-placeholder');
    if (!$root) return;

    const topMenuDesktopData = getJSONFromHtml(document.getElementById('site-header-top-menu-d-json')) as ITopMenuDesktop;
    if(!topMenuDesktopData) return;

    ReactDOM.render(
        <React.StrictMode>
            <TopMenuDesktop data={ topMenuDesktopData } />
        </React.StrictMode>,
        $root
    );
};